import React from 'react';
import Loading from './ui/loading/Loading.jsx';

const LoadingComponent = ({ isLoading, error }) => {
  // Handle the loading state
  if (isLoading) {
    return <Loading />;
  }
  // Handle the error state
  else if (error) {
    return <div>Sorry, there was a problem loading the page.</div>;
  }
  else {
    return null;
  }
};

export default LoadingComponent;



// WEBPACK FOOTER //
// ./src/components/LoadingComponent.jsx